import {
	ErasureRequestFormView,
	ErasureRequestListView,
	ErasureRequestPanelView,
	LegalHoldPanelView,
	PermissionDeniedView,
} from '@today/ui-domain'
import { useState } from 'react'
import { complianceCapabilities } from '@/auth/compliance-capabilities'
import { useViewerPermissions } from '@/auth/useViewerPermissions'
import { useErasureForm } from '@/hooks/compliance/useErasureForm'
import { useErasureList } from '@/hooks/compliance/useErasureList'
import { useErasureRequest } from '@/hooks/compliance/useErasureRequest'
import { useLegalHolds } from '@/hooks/compliance/useLegalHolds'
import { ComplianceNav } from './ComplianceNav'

/** One request's panel; keyed by id so its dialog and messages reset when another request opens. */
function ErasureRequestPanel({ id, onClose }: { id: string; onClose: () => void }) {
	return <ErasureRequestPanelView {...useErasureRequest(id, onClose)} />
}

/** `/admin/compliance/deletions` — erasure requests and legal holds (TO-232 compliance-admin-ui). */
export function ComplianceDeletionsPage() {
	const caps = complianceCapabilities(useViewerPermissions().permissions)
	const [selected, setSelected] = useState<string | null>(null)
	const list = useErasureList(setSelected)
	const form = useErasureForm(setSelected)
	const holds = useLegalHolds()
	return (
		<div className="flex flex-col gap-6 p-6">
			<ComplianceNav />
			<ErasureRequestListView {...list} />
			{selected ? <ErasureRequestPanel key={selected} id={selected} onClose={() => setSelected(null)} /> : null}
			{caps.manageErasures ? (
				<ErasureRequestFormView {...form} />
			) : (
				// ADR-0063 read-mostly: a viewer who can read but not create requests sees an
				// inline denied panel where the form would be — not an unexplained gap.
				<PermissionDeniedView
					title="Creating erasure requests is restricted"
					reason="You can view requests, but creating them needs additional permissions."
				/>
			)}
			<LegalHoldPanelView {...holds} />
		</div>
	)
}
